import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Select } from 'antd';

const Option = Select.Option;

export default class ArchiveBookClassesListPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let currentSemester = SharedTools.getCurrentSemester();
    // let semesters = SharedTools.getAllSemesters(currentSemester, 20171);

    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      classes: [],
      schoolId: null,
      semesters: [],
      currentSemester,
      semester: currentSemester,

      graduatedArray: []
    };
    // bind this
    this.toClassDetail = this.toClassDetail.bind(this);
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let schoolId, gradeId;
    if(this.state.role.associatName == 'school' || this.state.role.associatName == 'system'){
      schoolId = this.state.role.associatObj.id;
    }else {
      schoolId = this.state.role.associatObj.schoolId;
      gradeId = this.state.role.associatObj.id;
    }

    DataService.getSchoolInfo(schoolId).then((school) => {
      let currentSemester = this.state.currentSemester
      if (school && school.archive_semester_count == 1) {
        let year = this.state.currentSemester.toString().split('').slice(0, 4).join('');
        currentSemester = Number(year + '1');
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, 20171, school.archive_semester_count)

      this.setState({
        schoolId,
        gradeId,
        semester: currentSemester,
        semesters,
        currentSemester
      })
      this.loadClasses(currentSemester);

    }).catch((error) => {
      console.log(error);
    });
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  loadClasses(semester){
    let that = this, { schoolId, gradeId } = this.state;
    let data = {
      school_id: schoolId,
      info: 'archive_completion',
      semester
    }

    DataService.getClassList(data).then((classes) => {
      let classGradeListTemp = {}
      let classGradeList = [], graduatedArray = [];
      if (gradeId) {
        classes = classes.filter((record) => record.class_grade_id == gradeId)
      }
      classes.forEach(function(classItem){
        if(classGradeListTemp["grade_id"+classItem.class_grade_id]){
          classGradeListTemp["grade_id"+classItem.class_grade_id].classList.push(classItem)
        }else {
          classGradeListTemp["grade_id"+classItem.class_grade_id] = {
            id: classItem.class_grade_id,
            name: classItem.grade_name,
            classList: [classItem],
            is_graduated: classItem.is_graduated,
            graduate_date: classItem.graduate_date
          }
        }
      })
      for (let item in classGradeListTemp) {
        if (classGradeListTemp[item] && !classGradeListTemp[item].is_graduated) {
          classGradeList.push(classGradeListTemp[item])
        } else {
          graduatedArray.push(classGradeListTemp[item])
        }
      }
      if(that.state.role.associatName == 'classGrade'){
        let classGradeListGrade = [];
        classGradeListGrade.push(classGradeList.find(function(grade){
          return grade.id == that.state.role.associatObj.id
        }))
        this.setState({
          classes: classGradeListGrade,
          schoolId: data.school_id,
          info: data.info,
          graduatedArray: graduatedArray.filter((grade) => grade.id == that.state.role.associatObj.id)
        });
      }else {
        this.setState({
          classes: classGradeList,
          schoolId: data.school_id,
          info: data.info,
          graduatedArray
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  toClassDetail(e){
    let classId = e.currentTarget.dataset.id;
    hashHistory.push(`archive/book/classes/${classId}?semester=${this.state.semester}`)
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.loadClasses(value);
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    return (
      <div className="albums-manage-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="classes-wrapper">
          {this.state.classes.map(grade =>
            <div key={grade.id} style={{marginBottom:'40px'}}>
              <div className="class-grade">{grade.name}</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} onClick={this.toClassDetail} style={{height: 100}}>
                  <div className="class-box-name" >{classItem.name}</div>
                  <div className="class-box-info" >
                    已有{classItem.complete_pages_count ? classItem.complete_pages_count : 0}/{classItem.all_pages_count ? classItem.all_pages_count : 0}页
                    {/* 待审核{classItem.contents_need_reviewed_count ? classItem.contents_need_reviewed_count : 0}页 */}
                  </div>
                  {/* <div className="class-box-info" >已确认打印宝贝{classItem.complete_students_count ? classItem.complete_students_count : 0}/{classItem.student_count ? classItem.student_count : 0}人</div> */}
                </div>
              )}
            </div>
          )}
          <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer' }} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div>
          {this.state.showGraduated && this.state.graduatedArray.map(grade =>
            <div key={grade.id} style={{ marginBottom: '40px' }}>
              <div className="class-grade">{grade.name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} onClick={this.toClassDetail} style={{ height: 100 }}>
                  <div className="class-box-name" >{classItem.name}</div>
                  <div className="class-box-info" >
                    已有{classItem.complete_pages_count ? classItem.complete_pages_count : 0}/{classItem.all_pages_count ? classItem.all_pages_count : 0}页
                    {/* 待审核{classItem.contents_need_reviewed_count ? classItem.contents_need_reviewed_count : 0}页 */}
                  </div>
                  {/* <div className="class-box-info" >已确认打印宝贝{classItem.complete_students_count ? classItem.complete_students_count : 0}/{classItem.student_count ? classItem.student_count : 0}人</div> */}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveBookClassesListPage.jsx